import { Injectable } from '@angular/core';
import { AuthEventEmitter } from '../emitters/auth.event.emitter';
import { AddToHomeEventEmitter } from '../emitters/add-home.event.emitter';
import { UpdateEventEmitter } from '../emitters/update.event.emmiter';
import { ClubIDChangeEmmitter } from '../emitters/change-clubid.emitter';
import { HamBurgerEventEmitter } from '../emitters/ham-burger-event.emmiter';
import { SearchingEventEmitter } from '../emitters/searching.emmiter';

@Injectable({
    providedIn: 'root'
})
export class PubSubService {
    AuthStream: AuthEventEmitter;
    AddHomeStream: AddToHomeEventEmitter;
    UpdateStream: UpdateEventEmitter;
    ClubIDChangeStream: ClubIDChangeEmmitter;
    HamBurgerEventStream: HamBurgerEventEmitter;
    SearchingEventStream: SearchingEventEmitter

    constructor() {
        this.AuthStream = new AuthEventEmitter();
        this.AddHomeStream = new AddToHomeEventEmitter();
        this.UpdateStream = new UpdateEventEmitter();
        this.ClubIDChangeStream = new ClubIDChangeEmmitter();
        this.HamBurgerEventStream = new HamBurgerEventEmitter();
        this.SearchingEventStream = new SearchingEventEmitter();
    }
}
